import { utils } from '@ehi/global-marketing-interface';

const GMI = utils.getGmiConstants();

export default GMI;
